// @flow

import useResource from 'components/ResourceFill/hooks/useResource'
import { ResourceResponseContext } from 'components/ResourceFill/providers/ResourceResponseProvider'
import { ResourceSessionsContext } from 'components/ResourceFill/providers/ResourceSessionsProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

function useRedirects() {
  const history = useHistory()

  const { mode, isTablet, isPacket, redirectOnSubmitted, formIndex } =
    React.useContext(ResourceSharedContext) || {}

  const { currentSession } = React.useContext(ResourceSessionsContext) || {}

  const { response } = React.useContext(ResourceResponseContext) || {}

  const resource = useResource()

  const redirectToSuccess = React.useCallback(() => {
    if (!redirectOnSubmitted) return

    history.push(
      `/r/${currentSession?.messageCode ?? ''}/submitted${
        history?.location?.search ?? ''
      }`
    )
  }, [currentSession?.messageCode, history, redirectOnSubmitted])

  const redirectToScheduler = React.useCallback(() => {
    history.push(`/s/${currentSession?.messageCode ?? ''}`)
  }, [currentSession?.messageCode, history])

  React.useEffect(() => {
    if (mode === 'office') return

    if (isTablet) return

    const _response = isPacket ? currentSession?.packetResponse : response

    if (!_response) return

    const isSubmitted = _response.is_submitted
    const isScheduled = _response.is_scheduled

    const scheduleBeforeSubmit = resource?.settings?.schedule_before_submit
    const requireAppointment = resource?.settings?.require_appointment

    if (!requireAppointment && isSubmitted) {
      redirectToSuccess()

      return
    }

    if (scheduleBeforeSubmit && !isScheduled) {
      redirectToScheduler()

      return
    }

    if (!scheduleBeforeSubmit && isSubmitted) {
      redirectToScheduler()

      return
    }

    if (isSubmitted && isScheduled) {
      redirectToSuccess()
    }
  }, [
    mode,
    response,
    currentSession?.messageCode,
    currentSession?.packetResponse,
    currentSession?.responses,
    formIndex,
    history,
    isPacket,
    isTablet,
    redirectToScheduler,
    redirectToSuccess,
    resource?.settings?.require_appointment,
    resource?.settings?.schedule_before_submit,
  ])
}

export default useRedirects
